'use client'

import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import formatMsg from '../../util/formatMsg';
import { Checkbox, DatePicker, Modal, Radio } from 'antd';
import PrefixIconButton from '../buttons/prefixIconButton';
import colors from '../../libs/colorFactory';
import Helper from '../../util/helper';
import { timeutil } from '../..';


// In classnames fbs stands for 'filter-bottom-sheet' 

/* 
  structure of "filterNameToFilterMetaDataObjMap" = map('filterName', filterMetaDataObj) = [
    ['filterName'],  
    [
      optionsArr: [], 
      selectedVal: selectedFilterVal, 
      setSelectedVal: setSelectedFilterVal, 
      dontShowClearAll: boolean, 
      showAllOption: boolean, 
      filterType: 'multiSelect' | 'singleSelect' 
    ]
  ] 
*/


const FiltersBottomSheet = (props) => {

    const {
        firebase,
        filterNameToFilterMetaDataObjMap,
        showFiltersBottomSheet,
        setShowFiltersBottomSheet,
        setAppliedFiltersCount,
        defaultDateRangeType,
        paramPrefix
    } = props;

    const dateRangeKey = `${paramPrefix}dateRange`;
    const startDateKey = `${paramPrefix}startDate`;
    const endDateKey = `${paramPrefix}endDate`;
    const [tempDateRange, settempDateRange] = useState(null)
    const [dateRangeType, setDateRangeType] = useState(Helper.getUrlParam(dateRangeKey) || defaultDateRangeType || "lifetime")
    const [showCustomDateRangeModal, setshowCustomDateRangeModal] = useState(false);
    const overlayContainerRef = useRef(null);
    const bottomSheetRef = useRef(null);
    const [selectedFilterName, setSelectedFilterName] = useState(filterNameToFilterMetaDataObjMap?.size > 0 ? [...filterNameToFilterMetaDataObjMap][0][0] : null);
    const selectedFilterMetaDataObj = filterNameToFilterMetaDataObjMap.get(selectedFilterName);

    useEffect(() => {
        if (isFilterType('dateRange', selectedFilterMetaDataObj)) {
            if (dateRangeType != "Custom") Helper.setUrlParam(dateRangeKey, dateRangeType);
            switch (dateRangeType) {
                case "today":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance().startOf("day"), timeutil.getInstance().endOf("day")]);
                    break;
                case "yesterday":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance().subtract(1, "day").startOf("day"), timeutil.getInstance().subtract(1, "day").endOf("day")]);
                    break;
                case "thisWeek":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance().startOf("week"), timeutil.getInstance().endOf("week")]);
                    break;
                case "thisMonth":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance().startOf("month"), timeutil.getInstance().endOf("month")]);
                    break;
                case "lastMonth":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance().subtract(1, "month").startOf("month"), timeutil.getInstance().subtract(1, "month").endOf("month")]);
                    break;
                case "thisYear":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance().startOf("year"), timeutil.getInstance().endOf("year")]);
                    break;
                case "lifetime":
                    selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance(1), timeutil.getInstance(9999999999999)]);
                    break;
                case "customDateParam":
                    if (Helper.getUrlParam(startDateKey) && Helper.getUrlParam(endDateKey)) {
                        setDateRangeType("Custom")
                        selectedFilterMetaDataObj.setSelectedVal([timeutil.getInstance(Number(Helper.getUrlParam(startDateKey))), timeutil.getInstance(Number(Helper.getUrlParam(endDateKey)))])
                        settempDateRange([timeutil.getInstance(Number(Helper.getUrlParam(startDateKey))), timeutil.getInstance(Number(Helper.getUrlParam(endDateKey)))])
                    } else {
                        setDateRangeType("thisMonth");
                    }
                    break;
            }
        }
    }, [dateRangeType])

    useEffect(() => {
        if (isFilterType('dateRange', selectedFilterMetaDataObj) && selectedFilterMetaDataObj.selectedVal?.length === 2) {
            Helper.setUrlParam(startDateKey, timeutil.getEpoch(selectedFilterMetaDataObj.selectedVal[0]))
            Helper.setUrlParam(endDateKey, timeutil.getEpoch(selectedFilterMetaDataObj.selectedVal[1]))
        }
    }, [selectedFilterMetaDataObj?.selectedVal])

    const handleFBSCloseOnOutsideClick = (e) => {
        if (
            overlayContainerRef.current &&
            overlayContainerRef.current.contains(e.target) &&
            bottomSheetRef.current &&
            !bottomSheetRef.current.contains(e.target)
        ) {
            closeBottomSheet();
        }
    }


    useEffect(() => {

        let appliedFiltersCount = 0;

        filterNameToFilterMetaDataObjMap && [...filterNameToFilterMetaDataObjMap].map(([filterName, filterMetaDataObj]) => {
            if (isFilterType('singleSelect', filterMetaDataObj) && filterMetaDataObj.selectedVal) {
                appliedFiltersCount++;
            }
            else if (isFilterType('multiSelect', filterMetaDataObj) && filterMetaDataObj.selectedVal?.length) {
                appliedFiltersCount++;
            }
        });

        setAppliedFiltersCount(appliedFiltersCount);

    }, [filterNameToFilterMetaDataObjMap]);


    function selectFilterName(filterName) {
        if (filterName !== selectedFilterName) {
            setSelectedFilterName(filterName);
        }
    }

    function closeBottomSheet() {
        setShowFiltersBottomSheet(false);
    }


    const handleRadioDeselection = (key: string) => {
        if (key === selectedFilterMetaDataObj.selectedVal) {
            selectedFilterMetaDataObj.setSelectedVal(undefined);
        }
    }

    function getAllOptionValue() {
        switch (selectedFilterName) {
            case 'filterLabel.packages':
                return "all packages";
            case 'filterLabel.centers':
                return "all centers";
            case 'filterLabel.instructors':
                return "allInstructors";
            case 'filterLabel.participants':
                return "all participants";
            case 'filterLabel.accounts':
                return "all accounts";
            case 'filterLabel.ageRange':
                return "all";
            case 'filterLabel.status':
                return "all status";
            case 'filterLabel.type':
                return "all types";
            case 'filterLabel.visibility':
                return "all";
            case 'filterLabel.batches':
                return "all batches";
        }
    }

    function getAllOptionLabel() {

        const showCustomLabel = [];

        if (showCustomLabel.includes(selectedFilterName)) {
            switch (selectedFilterName) {
                case 'filterLabel.packages':
                    return formatMsg("caps.allPackages");
                case 'filterLabel.centers':
                    return formatMsg("allCenters");
                case 'filterLabel.instructors':
                    return formatMsg("caps.allInstructors");
                case 'filterLabel.participants':
                    return formatMsg(
                        "allParticipants",
                        {
                            Participants: Helper.getSelectedUserTypeName(
                                firebase,
                                formatMsg('participants')
                            )
                        }
                    );
                case 'filterLabel.accounts':
                    return formatMsg('caps.allAccounts');
                case 'filterLabel.ageRange':
                    return formatMsg("All");
                case 'filterLabel.status':
                    return formatMsg("caps.AllStatus");
                case 'filterLabel.type':
                case 'filterLabel.visibility':
                    return formatMsg("allTypes");
                case 'filterLabel.batches':
                    return formatMsg("allBatches");
            }

        }
        else return formatMsg("selectAll");
    }

    function getOptionValue(option) {
        switch (selectedFilterName) {
            case 'filterLabel.packages':
            case 'filterLabel.centers':
            case 'filterLabel.instructors':
            case 'filterLabel.participants':
            case 'filterLabel.ageRange':
            case 'filterLabel.accounts':
            case 'filterLabel.batches':
                return option.id;
            case 'filterLabel.visibility':
                return option.key;

            case 'filterLabel.status':
            case 'filterLabel.type':
            case 'filterLabel.timeslots':
                return option;
        }
    }

    function getOptionLabel(option) {
        switch (selectedFilterName) {
            case 'filterLabel.packages':
            case 'filterLabel.centers':
            case 'filterLabel.instructors':
            case 'filterLabel.participants':
            case 'filterLabel.accounts':
            case 'filterLabel.batches':
                return option.name;
            case 'filterLabel.type':
                return option;
            case 'filterLabel.visibility':
                return option.label;

            case 'filterLabel.ageRange':
                return option.value ? formatMsg(option.value) : Helper.getAgeRangeFormat(option);
            case 'filterLabel.status':
            case 'filterLabel.timeslots':
                return formatMsg(option);
        }
    }

    function clearAllFilters() {
        [...filterNameToFilterMetaDataObjMap]?.map(([filterName, filterMetaDataObj]) => {
            filterMetaDataObj.setSelectedVal(undefined);
        })
        closeBottomSheet();
    }

    function isFilterType(
        toBeFilterType: string,
        filterMetaDataObj: Record<string, any>
    ) {
        return (filterMetaDataObj.filterType === toBeFilterType);
    }

    function clearCurrFilter() {
        if (selectedFilterMetaDataObj) {
            selectedFilterMetaDataObj?.setSelectedVal(undefined);
        }
    }

    return (
        <div
            className={`${showFiltersBottomSheet ? 'fbs-visible' : 'fbs-invisible'} fbs-overlay`}
            ref={overlayContainerRef}
            onClick={handleFBSCloseOnOutsideClick}
        >
            <div className='fbs' ref={bottomSheetRef}>
                <div className='fbs-heading-container'>
                    <div className='fbs-heading'>
                        {formatMsg('filters')}
                    </div>
                    <div
                        className='close-fbs-icon-container'
                        onClick={closeBottomSheet}
                    >
                        <img
                            className='close-fbs-icon'
                            src='/images/closeGray.png'
                        />
                    </div>
                </div>

                <div className='filters-body-container'>
                    <div className='filter-lists'>
                        {
                            filterNameToFilterMetaDataObjMap &&
                            [...filterNameToFilterMetaDataObjMap]?.map(([filterName, filterMetaDataObj], key) => {
                                return (
                                    <div
                                        key={key}
                                        className={`filter-name ${(selectedFilterName === filterName) ? 'filter-name-selected' : ''}`}
                                        style={{
                                            cursor: filterMetaDataObj.disabled ? 'not-allowed' : 'pointer',
                                            pointerEvents: filterMetaDataObj.disabled ? 'none' : 'auto',
                                            opacity: filterMetaDataObj.disabled ? 0.6 : 1
                                        }}
                                        onClick={() => {
                                            if (filterMetaDataObj.disabled) {
                                                return null;
                                            }
                                            selectFilterName(filterName)
                                        }}
                                    >
                                        <div>
                                            {
                                                filterName === "filterLabel.participants" ?
                                                    Helper.getSelectedUserTypeName(firebase, formatMsg(filterName), undefined, undefined) :
                                                    formatMsg(filterName)
                                            }
                                        </div>
                                        <div className='fbs-filter-count'>
                                            {
                                                isFilterType('singleSelect', filterMetaDataObj) &&
                                                    filterMetaDataObj.selectedVal ? "1" : ""
                                            }
                                            {
                                                isFilterType('multiSelect', filterMetaDataObj) &&
                                                    filterMetaDataObj.selectedVal?.length ? filterMetaDataObj.selectedVal.length : ""
                                            }
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    {
                        Boolean(selectedFilterName && selectedFilterMetaDataObj && filterNameToFilterMetaDataObjMap) &&
                        <div className='selected-filter-name-options'>
                            {
                                isFilterType('dateRange', selectedFilterMetaDataObj) &&
                                <Radio.Group
                                    onChange={(e) => {
                                        if (e.target.value === "custom") {
                                            setDateRangeType("custom")
                                        }
                                        else setDateRangeType(e.target.value)
                                    }}
                                    value={dateRangeType}
                                    className='custom-fbs-radio-group'
                                >
                                    {
                                        Helper.getDateRanges()?.map((option) => {
                                            return (
                                                <Radio
                                                    className='custom-fbs-radio'
                                                    value={option}
                                                    onClick={() => option === "custom" ? setshowCustomDateRangeModal(true) : null}
                                                >
                                                    {option === "Custom" ? formatMsg("customDateRange") : formatMsg(option)}
                                                </Radio>
                                            )
                                        })
                                    }
                                </Radio.Group>
                            }
                            {
                                isFilterType('singleSelect', selectedFilterMetaDataObj) &&
                                <Radio.Group
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value) selectedFilterMetaDataObj.setSelectedVal(value);
                                    }}
                                    value={selectedFilterMetaDataObj.selectedVal}
                                    className='custom-fbs-radio-group'
                                >
                                    {
                                        selectedFilterMetaDataObj.showAllOption &&
                                        <Radio
                                            value={getAllOptionValue()}
                                            className='custom-fbs-radio'
                                            onClick={() => handleRadioDeselection(getAllOptionValue())}
                                        >
                                            {getAllOptionLabel()}
                                        </Radio>
                                    }
                                    {
                                        selectedFilterMetaDataObj &&
                                        selectedFilterMetaDataObj.optionsArr?.map((option) => {
                                            return (
                                                <Radio
                                                    className='custom-fbs-radio'
                                                    value={getOptionValue(option)}
                                                    onClick={() => handleRadioDeselection(getOptionValue(option))}
                                                >
                                                    {getOptionLabel(option)}
                                                </Radio>
                                            )
                                        })
                                    }
                                </Radio.Group>
                            }
                            {
                                isFilterType('multiSelect', selectedFilterMetaDataObj) &&
                                Boolean(selectedFilterMetaDataObj.optionsArr?.length) &&
                                <>
                                    <div className='options-div'>
                                        {
                                            (selectedFilterMetaDataObj.selectedVal?.length !== selectedFilterMetaDataObj.optionsArr.length) &&
                                            selectedFilterMetaDataObj.showAllOption &&
                                            <PrefixIconButton
                                                title={getAllOptionLabel()}
                                                type='primary'
                                                onClick={() => {
                                                    selectedFilterMetaDataObj.setSelectedVal([
                                                        getAllOptionValue(),
                                                        ...(selectedFilterMetaDataObj.selectedVal || [])
                                                    ]);
                                                }}
                                            />
                                        }
                                        {
                                            ((selectedFilterMetaDataObj.selectedVal?.length > 0) &&
                                                !selectedFilterMetaDataObj.dontShowClearAll) &&
                                            <PrefixIconButton
                                                title={formatMsg('clearAll')}
                                                type='primary'
                                                onClick={clearCurrFilter}
                                            />
                                        }
                                    </div>
                                    <Checkbox.Group
                                        value={selectedFilterMetaDataObj.selectedVal}
                                        onChange={(value) => {
                                            if (value) selectedFilterMetaDataObj.setSelectedVal(value);
                                        }}
                                    >
                                        {
                                            selectedFilterMetaDataObj &&
                                            selectedFilterMetaDataObj.optionsArr.map((option) => {
                                                return (
                                                    <Checkbox
                                                        className='custom-fbs-checkbox'
                                                        value={getOptionValue(option)}
                                                    >
                                                        {getOptionLabel(option)}
                                                    </Checkbox>
                                                )
                                            })
                                        }
                                    </Checkbox.Group>
                                </>
                            }
                        </div>
                    }
                </div>

                <div className='fbs-footer-container'>
                    <PrefixIconButton
                        title={formatMsg("clearAll")}
                        border={true}
                        borderColor={colors.color_purple}
                        fontColor={colors.color_purple}
                        padding='5px 20px'
                        borderRadius='8px'
                        onClick={clearAllFilters}
                    />
                </div>
            </div>
            <Modal
                title={"Select date range"}
                open={showCustomDateRangeModal}
                onOk={() => {
                    Helper.setUrlParam(dateRangeKey, "customDateParam");
                    selectedFilterMetaDataObj.setSelectedVal(tempDateRange)
                    setshowCustomDateRangeModal(false)
                }}
                onCancel={() => {
                    settempDateRange(null)
                    setshowCustomDateRangeModal(false)
                }}
                okText="Save"
                maskClosable={false}
            >
                <DatePicker.RangePicker
                    format={"DD MMM'YY"}
                    value={tempDateRange}
                    onChange={settempDateRange}
                    allowClear={false}
                    style={{ width: "100%", marginTop: 24, marginBottom: 24 }}
                />
            </Modal>
        </div>
    )
}

export default FiltersBottomSheet; 